/**
 * Normalize grocery category strings so grouping matches human intent:
 * trim, replace unicode/NBSP spaces, collapse runs, then case-fold for keys.
 */

/** Matches common unicode space chars that look like plain spaces in UI. */
const _SPACE_CLASS =
  /[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000\uFEFF]/g

/**
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeGroceryCategoryString(raw) {
  if (raw == null || typeof raw !== 'string') return ''
  return raw.replace(_SPACE_CLASS, ' ').trim().replace(/\s+/g, ' ')
}

/**
 * Lowercase normalized category for a stable grouping key; empty if missing/blank.
 * @param {unknown} raw
 * @returns {string}
 */
export function groceryCategoryGroupingKey(raw) {
  const n = normalizeGroceryCategoryString(raw)
  return n ? n.toLowerCase() : ''
}

/**
 * Header label for a group: title-case each letter-run so "baking" / "BAKING" /
 * "Baking" share one bucket with a consistent heading.
 * @param {string} lowerKey From {@link groceryCategoryGroupingKey}
 * @returns {string}
 */
export function displayGroceryCategoryFromKey(lowerKey) {
  if (!lowerKey) return ''
  return lowerKey.replace(/\b\p{L}+/gu, (w) => {
    if (!w.length) return w
    return w.charAt(0).toLocaleUpperCase() + w.slice(1).toLocaleLowerCase()
  })
}
